module.exports = __webpack_public_path__ + "static/img/moriarty-tyler.77cf368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moriarty-tyler.jpg
// module id = 2Jn+
// module chunks = 0